import { kuiperClassNames } from '@opallabs/kuiper'

import './styles.scss'

const DayView = () => <div className={kuiperClassNames('day-view')} />

export default DayView
